import { render } from "./AvatarsGallery.vue?vue&type=template&id=b5b5767c&scoped=true"
import script from "./AvatarsGallery.vue?vue&type=script&lang=js"
export * from "./AvatarsGallery.vue?vue&type=script&lang=js"

import "./AvatarsGallery.vue?vue&type=style&index=0&id=b5b5767c&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b5b5767c"]])

export default __exports__
import QPagination from 'quasar/src/components/pagination/QPagination.js';
import qInstall from "../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QPagination});
